module.exports = __webpack_public_path__ + "web/img/xzreport.829dfb79.png";